import { commonFilter } from './filter';

export default {
  pageName: 'AI Topic Analysis',
  pageId: '26021',
  pagePath: '/opinion/AIAnalysisHub/AITopicAnalysis',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    KeywordSearchType: {
      buttonId: '2602101',
    },
    // GPT_Type: {
    //   buttonId: '2602102',
    // },
    EditPrompt: {
      buttonId: '2602103',
    },
    TypeTAB: {
      buttonId: '2602104',
    },
    GPTRegenerate: {
      buttonId: '2602107',
    },
    GPTCopy: {
      buttonId: '2602108',
    },
    GPTFullScreen: {
      buttonId: '2602109',
    },
    GotoFeeds: {
      buttonId: '2602110',
    },
    ReviewTypeTAB: {
      buttonId: '2602112',
    },
    SentimentStatisticsTAB: {
      buttonId: '2602113',
    },
    GPT_Get_Btn: {
      buttonId: '2602126',
    },
    GPT_Confirm: {
      buttonId: '2602127',
    },
    GPT_Stop: {
      buttonId: '2602128',
    },
    GPT_Agent: {
      buttonId: '2602129',
    },
    SelectVideoSummary: {
      buttonId: '2602130',
    },
    SelectCommentSummary: {
      buttonId: '2602131',
    },
    GPT_Options: {
      buttonId: '2602132',
    },
    GenerateReport: {
      buttonId: '2602133',
    },
    RegularListening: {
      buttonId: '2602134',
    },
    RegularListeningConfirm: {
      buttonId: '2602135',
    },
  },
  card: {
    ChartCard: {
      bar: {
        buttonId: '2602114',
      },
      line: {
        buttonId: '2602115',
      },
      pie: {
        buttonId: '2602116',
      },
      table: {
        buttonId: '2602117',
      },
      'sentiment-s-bar': {
        buttonId: '2602118',
      },
      'common-bar': {
        buttonId: '2602119',
      },
      stack_line: {
        buttonId: '2602120',
      },
      download: {
        buttonId: '2602121',
      },
    },
    GPT: {
      refresh: {
        buttonId: '2602122',
      },
      copy: {
        buttonId: '2602123',
      },
      fullscreen: {
        buttonId: '2602124',
      },
      save: {
        buttonId: '2602125',
      },
    },
  },
};
